<script lang="ts">
  import { Container } from '@shared/ui/container';
  import { Content } from '@shared/ui/content';
  import { ContentTable } from '@shared/ui/content-table';
  import { timeToRead } from '@shared/utils';

  import type { NewsFromOneResponse } from '@entities/news/types';

  import Header from './header.svelte';

  export let article: NewsFromOneResponse;

  $: readTime = timeToRead(article.content?.blocks);
</script>

<svelte:head>
  <style>
    html {
      scroll-behavior: smooth;
    }
  </style>
</svelte:head>

<Container containerClass="pb-12">
  <Header
    publicationDate="{article.custom_publication_date}"
    title="{article.header}"
    cover="{article.cover}"
    author="{article.author}"
    {readTime}
  />

  <div class="mx-auto max-w-[744px]">
    <ContentTable blocks="{article.content?.blocks}" classes="mb-8" />

    {#if article.content?.blocks && article.content.blocks.length}
      <Content blocks="{article.content?.blocks}" />
    {/if}
  </div>
</Container>
